import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/psqi";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllPsqiByTax(params.tratamientoId);
}

export function PsqiList(props) {
  const [psqiList, setPsqi] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllPsqiByTax(props.id).then(setPsqi).catch(console.log);
  }, [props.id]);
  return (
    <>
      {psqiList?.length ? (
        <ul className="psqi cpt-list">
          {psqiList
            .sort((a, b) => {
              // Parse the dates from the meta objects
              const dateA = new Date(a.meta.metaFecha);
              const dateB = new Date(b.meta.metaFecha);
              // Compare the dates (descending order)
              return dateB - dateA;
            })
            .map((psqi) => (
              <li key={psqi.id}>
                <NavLink to={`${props.id}/cuestionarios/psqi/${psqi.id}`}>
                  {`${FormatDate(psqi.meta.metaFecha)}`}
                </NavLink>
              </li>
            ))}
        </ul>

          ) : (
            <></>
          )}
    </>
  );
}



export function PsqiListContent() {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>PSQI</h1>
      </div>
      <div id="actions">
        {<Link className="button is-link" to={`new`}>Nuevo</Link>}
      </div>
    </>
  );
}